import logo from "assets/images/logo.png";
import { useState, useEffect } from "react";
import { useData } from "context/DataContext";
import { v4 as uuidv4 } from "uuid";
import { db, ref, set } from "config/Firebase";
import Loader from "utils/Loader";
import Modal from "utils/Modal";
import Alert from "utils/Alert";

const ProjectTab = ({ proposal, name, viewMode }) => {
  // modal
  const [modal, setModal] = useState(false);
  // submitting
  const [submitting, setSubmitting] = useState(false);
  //
  const [alert, setAlert] = useState({ open: false, msg: "", type: "" });
  //
  const [state, setState] = useState({ proposal: "", links: [] });
  //
  const { data } = useData();

  // sve record
  const saveData = () => {
    setSubmitting(true);
    set(ref(db, "store/" + name), {
      links: state.links || [],
      proposal: state?.proposal || "",
    })
      .then(() => {
        setModal(false);
        setSubmitting(false);
        setAlert({
          open: true,
          msg: "Data Save successfully.",
          type: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        setModal(false);
        setSubmitting(false);
        setAlert({ open: true, msg: "Something went wrong!", type: "error" });
      });
  };

  //
  useEffect(() => {
    setState({
      proposal: data[name]?.proposal,
      links: data[name]?.links,
    });
  }, [modal]);

  // add new
  const addNewLink = () => {
    // let newId = uuidv4();
    let newId = new Date().getTime();
    let oldData = Object.values(state?.links || {}) || [];
    oldData.unshift({
      id: newId,
      value: "",
    });
    setState({
      ...state,
      links: oldData,
    });
  };

  // remove link
  const deleteLink = (num) => {
    let s = Object.values(state.links).filter((v) => v.id !== num);
    let obj = {};
    s.map((d, i) => {
      obj = {
        ...obj,
        [d.id]: d,
      };
    });
    setState({
      ...state,
      links: obj,
    });
  };

  // copy text
  const copyText = async (address, id) => {
    if (id) {
      let d = document.getElementById(id);
      var range = document.createRange();
      window.getSelection().removeAllRanges();
      range.selectNode(d);
      window.getSelection().addRange(range);
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      setAlert({
        type: "success",
        open: true,
        msg: "Text copied to clipboard successfully.",
      });
    } else {
      navigator.clipboard
        .writeText(address)
        .then(() => {
          setAlert({
            type: "success",
            open: true,
            msg: "Text copied to clipboard successfully.",
          });
        })
        .catch((err) => {
          console.log(err);
          setAlert({
            type: "error",
            open: true,
            msg: "Something went wrong!",
          });
        });
    }
  };

  let startIndex;

  // 
  function dragStart(e) {
    startIndex = e.target.closest('div').getAttribute('data-index');
  }

  // 
  function dragEnter(e) {
    e.target.classList.add("over");
  }

  // 
  function dragLeave(e) {
    e.target.classList.remove("over");
  }

  // ========= prevent drag over default  ===============
  function dragOver(e) {
    e.preventDefault()
  }

  // =============== drop ====================
  function dragDrop(e) {
    let endIndex = +e.target.closest('div').getAttribute('data-index')
    e.target.classList.remove("over");
    e.target.focus();
    swapItems(startIndex,endIndex)
  }

  //================== swap items =====================
  function swapItems(startIndex,endIndex) {
    let oldData =  Object.values(state.links);
    let st =  oldData[startIndex];
    let ed = oldData[endIndex];
    oldData[startIndex] = ed;
    oldData[endIndex] = st;
    setState({
      ...state,
      links: oldData,
    });
    startIndex = null
  }

  //============= on input change ================
  const handleInputChange = (e,id) => {
    let oldData = Object.values(state?.links) || [];
    oldData[id] = {id: oldData[id]?.id, value: e.target?.value};
    setState({
      ...state,
      links: oldData
    });
  };
    
  return (
    <section>
       {/*================ Modal ===================*/}
       <Modal open={modal}>
        <div className="cs_modal_wrapper">
          <div  className="cs_modal_backdrop"  onClick={() => setModal(false)}></div>
          <div className="cs_modal">
            <header className="cs_modal_header cs_row align-items-center justify-content-between">
              <div>
                <img src={logo} alt="Smash Code" />
              </div>
              <button onClick={() => setModal(false)} className="cs_icon_btn">
                &times;
              </button>
            </header>
            <div className="cs_modal_body">
              <h3>{name?.replaceAll("_", " ")?.toUpperCase()} :</h3>
              {proposal && (
                <>
                  <h4>Bidding Request</h4>
                  <br />
                  <textarea
                    placeholder="Enter"
                    value={state?.proposal}
                    onChange={(e) => {
                      setState({ ...state, proposal: e.target?.value });
                    }}
                  />
                  <br /> <br />
                </>
              )}
              <div className="cs_row justify-content-between align-items-center">
                <h4>Projects Links</h4>
                <button onClick={addNewLink} className="cs_icon_btn">
                  +
                </button>
              </div>
              <br />
              {/* // ?.reverse() */}
              {state?.links &&
                Object.values(state?.links)?.map((link, i) => (
                    <div
                      draggable
                      onDragStart={dragStart}
                      onDragOver={dragOver}
                      // onDrag={dragEnter}
                      onDragEnter={dragEnter}
                      // onDragEnd={dragEnter}
                      onDrop={dragDrop}
                      onDragLeave={dragLeave}
                      data-index={i}
                      className="draggable cs_row my-2 justify-content-between align-items-center"
                      key={i}
                    >
                      <input
                        placeholder="Enter"
                        value={link?.value}
                        onChange={(e) => handleInputChange(e,i,link?.id)}
                      />
                      &nbsp;
                      <button
                        onClick={() => deleteLink(link.id)}
                        className="cs_icon_btn sm"
                      >
                        &times;
                      </button>
                    </div>
                  ))}
            </div>
            <footer className="cs_modal_footer cs_row align-items-center justify-content-between">
              <span></span>
              <button className="cs_btn" onClick={saveData}>
                Save &#10004;
              </button>
            </footer>
          </div>
          {submitting && <Loader type="imgloader_fixed" />}
        </div>
      </Modal>
      <br />
      <div className="cs_row px-2 justify-content-between">
        <h1 className="text_center">
          {name?.replaceAll("_", " ").toUpperCase()} :
        </h1>
        {!viewMode && (
          <button
            className="cs_btn"
            onClick={() => {
              setModal(true);
              setState({
                proposal: data[name]?.proposal,
                links: data[name]?.links,
              });
            }}
          >
            Add New +
          </button>
        )}
      </div>

      {proposal && data[name].proposal && (
        <>
          <br />
          <h1 className="px-2">Bidding Request :</h1>
          <br />
          <p className="px-2 bidding_para">
            {
              <button
                onClick={() => copyText(data[name].proposal)}
                className="cs_icon_btn sm bid_copy_btn"
              >
                &#9750;
              </button>
            }
            {data[name].proposal}
          </p>
          <br />
        </>
      )}

      {data[name]?.links && (
        <>
          <br />
          <h1 className="px-2">Projects Links :</h1>
        </>
      )}
      <br />
      {data[name]?.links && Object.values(data[name]?.links).length > 0 && (
        <button onClick={() => copyText(null, "links_ol")} className="cs_btn">
          {" "}
          Copy All Links
        </button>
      )}
      <br />
      <ul id="links_ol">
        {data[name]?.links &&
          Object.values(data[name]?.links)?.map((v, i) => (
            <li className="w-100" key={i}>
              {v?.value}
            </li>
          ))}
      </ul>
      <ol type="1" className="px-2">
        {data[name]?.links &&
          Object.values(data[name]?.links)?.map((v, i) => (
            <li
              key={i}
              className="links_list cs_row align-items-center flex-wrap"
            >
              {i + 1} : &nbsp;
              <a href={v?.value} target="_blank" rel="noopener noreferrer">
                {v?.value}
              </a>
              &nbsp;
              {
                <button
                  onClick={() => copyText(v?.value)}
                  className="cs_icon_btn sm"
                >
                  &#9750;
                </button>
              }
            </li>
          ))}
      </ol>
     
      {/* ========== Alert ==================== */}
      <Alert data={alert} setAlert={setAlert} />
    </section>
  );
};

export default ProjectTab;
